// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__B_A2n","tab":"ProcedureTabs_tab__1GBJV"};